import React from "react";
import "../service.css";
import { Link } from "react-router-dom";

export const Lounge = () => {
  return (
    <div>
      <div className="tj-inner-banner">
        <div className="container">
          <h2>Services On Our Vehicle</h2>
        </div>
      </div>

      <div className="tj-breadcrumb">
        <div className="container">
          <ul className="breadcrumb-list">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li className="active">Services On Our Vehicle</li>
          </ul>
        </div>
      </div>
      <div className="container">
        <div style={{ padding: "30px", display: "flex" }}></div>

        <h1 className="farex-h1" style={{ textAlign: "center" }}>
          Services On Our Vehicle
        </h1>

        <img
          src="image/carfleet.png"
          style={{objectFit:"cover"}}
          className="basic-page-header-image basic-page-paragraph-container"
          alt="hiremebus"
          data-lazyload="https://cdn-cf.cms.farexbus.com/drupal-assets/styles/header_image_basic_page_0_5x/s3/2024-01/india_farexbus_interior.jpg 390w, https://cdn-cf.cms.farexbus.com/drupal-assets/styles/header_image_basic_page/s3/2024-01/india_farexbus_interior.jpg 780w, https://cdn-cf.cms.farexbus.com/drupal-assets/styles/header_image_basic_page_1_5x/s3/2024-01/india_farexbus_interior.jpg 1170w"
          sizes="100vw"
        />

        <div id="section-43557" style={{ clear: "both" }}>
          <div
            className="farex-text basic-page-paragraph-container"
            style={{ overflowY: "auto" }}
          >
            <h3>Our services on board with&nbsp;Hireme</h3>
            <p>
              When you travel with Hireme you are guaranteed&nbsp;the best
              service. On board our&nbsp;buses you will find extra legroom for
              all bus configurations, USB plug sockets&nbsp;and a lot of room
              for your luggage.
            </p>
          </div>
        </div>

        <div id="section-43564" style={{ clear: "both" }}>
          <section className="basic-page-paragraph-container">
            <div className="farex-grid">
              <div className="farex-col-12 farex-col-6-md text-with-icon-item">
                <div className="farex-grid">
                  <div className="farex-col-2">
                    <farex-icon
                      size="cover"
                      name="farex-icon-sit"
                      color="primary"
                      aria-hidden="true"
                    >
                      <div className="inner color color-primary size size-cover">
                        <svg
                          fill="#dd3751"
                          height={"60px"}
                          width={"60px"}
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          className="farex-icon sit"
                        >
                          <path d="m19.61 18.98-2.55-6-.03-.05-.1-.22-.1-.18-.13-.17-.14-.17-.16-.14-.16-.14-.2-.12-.17-.1-.22-.07-.2-.06q-.1-.02-.2-.03l-.24-.02-.06-.01h-1.64a.6.6 0 0 1-.6-.6V7.6a.6.6 0 0 0-.59-.6H8.35a.6.6 0 0 0-.6.6v7.8c0 .33.27.6.6.6h5.04l2.02 4.52a2.24 2.24 0 1 0 4.2-1.54m-2.02 1-.08.02a.24.24 0 0 1-.22-.16l-.02-.07-.03-.07-2.02-4.52-.54-1.18H9.76V9h.97v1.9a2.6 2.6 0 0 0 2.6 2.6h1.6l.06.01h.04l.02.02h.02l.02.02.02.01.01.02.02.02.01.01.02.04.02.04.06.12 2.5 5.88a.25.25 0 0 1-.15.3M10 6.5A2.25 2.25 0 1 0 10 2a2.25 2.25 0 0 0 0 4.5M12.25 18a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v8h5a1 1 0 0 1 1 1"></path>
                        </svg>
                      </div>
                    </farex-icon>
                  </div>
                  <div className="farex-col-10">
                    <h3 className="farex-h3 farex-h3--section-header">Legroom</h3>
                    <div className="farex-text">
                      <p>
                        Hireme guarantees you a seat with extra legroom. Our
                        modern buses are equipped with comfortable seats and
                        plenty of space. Beds are also available in selected
                        rides, meaning even more comfort and space.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="farex-col-12 farex-col-6-md text-with-icon-item">
                <div className="farex-grid">
                  <div className="farex-col-2">
                    <farex-icon
                      size="cover"
                      name="farex-icon-socket"
                      color="primary"
                      aria-hidden="true"
                    >
                      <div className="inner color color-primary size size-cover">
                        <svg
                          fill="#dd3751"
                          height={"60px"}
                          width={"60px"}
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          className="farex-icon socket"
                        >
                          <path d="M21.7 6.55a1 1 0 0 0-1.4 0l-2.7 2.7-2.82-2.84 2.7-2.7a1 1 0 1 0-1.43-1.42L13.36 5l-1.7-1.69a.6.6 0 0 0-.42-.17.6.6 0 0 0-.42.17L7 7.12a7 7 0 0 0-.65 9.13L2.29 20.3a1 1 0 1 0 1.42 1.42l4.05-4.04a7 7 0 0 0 9.14-.65l3.82-3.82a.6.6 0 0 0 0-.85l-1.7-1.7 2.69-2.68a1 1 0 0 0 0-1.42m-6.22 9.06a4.97 4.97 0 0 1-7.07 0 5 5 0 0 1 0-7.08l2.83-2.82 1.42 1.41 4.21 4.22.02.03.04.02 1.38 1.39z"></path>
                        </svg>
                      </div>
                    </farex-icon>
                  </div>
                  <div className="farex-col-10">
                    <h3 className="farex-h3 farex-h3--section-header">
                      Power outlets
                    </h3>
                    <div className="farex-text">
                      <p>
                        Want to surf the Internet, chat or work on your laptop,
                        but your battery is dead? No problem! Just look out for
                        the USB socket or ask our friendly hosts where to find
                        one of the many outlets in our Hireme vehicle.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="farex-col-12 farex-col-6-md text-with-icon-item">
                <div className="farex-grid">
                  <div className="farex-col-2">
                    <farex-icon
                      size="cover"
                      name="farex-icon-luggage"
                      color="primary"
                      aria-hidden="true"
                    >
                      <div className="inner color color-primary size size-cover">
                        <svg
                          fill="#dd3751"
                          height={"60px"}
                          width={"60px"}
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          className="farex-icon luggage"
                        >
                          <path d="M15 8a1 1 0 0 1-1 1h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 1 1m4-1v11a3 3 0 0 1-2.51 2.95l.01.05a1 1 0 0 1-2 0h-5a1 1 0 0 1-2 0l.01-.05A3 3 0 0 1 5 18V7a3 3 0 0 1 3-3h2.5V2.6c0-.33.27-.6.6-.6h1.8c.33 0 .6.27.6.6V4H16a3 3 0 0 1 3 3m-2 0c0-.54-.46-1-1-1H8c-.54 0-1 .46-1 1v11c0 .54.46 1 1 1h8c.54 0 1-.46 1-1z"></path>
                        </svg>
                      </div>
                    </farex-icon>
                  </div>
                  <div className="farex-col-10">
                    <h3 className="farex-h3 farex-h3--section-header">Luggage</h3>
                    <div className="farex-text">
                      <p>
                        Our Hireme vehicle offer you enough space for your
                        luggage. Store your hand luggage in the overhead
                        compartments or under the seat slots and our friendly
                        hosts will assist you in loading your hold luggage. All
                        details about can be found in the&nbsp;
                        <Link to={"/luggage-policy"}>luggage policy</Link>.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="farex-col-12 farex-col-6-md text-with-icon-item">
                <div className="farex-grid">
                  <div className="farex-col-2">
                    <farex-icon
                      size="cover"
                      name="ac"
                      color="primary"
                      aria-hidden="true"
                    >
                      <div className="inner color color-primary size size-cover">
                        <svg
                          fill="#dd3751"
                          height={"60px"}
                          width={"60px"}
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          className="farex-icon ac"
                        >
                          <path d="m20.42 12.97-3.64.64-1.84-1.06a3 3 0 0 0 0-1.1l1.84-1.06 3.64.64a1 1 0 1 0 .34-1.97l-1.28-.22.81-.47a1 1 0 0 0-1-1.74l-.81.48.44-1.23a1 1 0 0 0-1.88-.69l-1.26 3.47-1.84 1.07a3 3 0 0 0-.94-.55V7.05l2.37-2.82a1 1 0 1 0-1.53-1.29l-.84 1V3a1 1 0 0 0-2 0v.94l-.84-1a1 1 0 0 0-1.54 1.29L11 7.05v2.13q-.53.2-.94.55L8.21 8.66 6.95 5.19a1 1 0 1 0-1.88.69l.45 1.23-.82-.48a1 1 0 0 0-1 1.74l.82.47-1.29.22a1 1 0 1 0 .35 1.97l3.63-.64 1.84 1.06a3 3 0 0 0 0 1.1L7.21 13.6l-3.63-.64a1 1 0 1 0-.35 1.97l1.3.23-.83.47a1 1 0 0 0 1 1.73l.82-.47-.45 1.23a1 1 0 0 0 1.88.69l1.27-3.47 1.84-1.07q.43.36.94.54v2.13l-2.38 2.83a1 1 0 1 0 1.54 1.29l.84-1V21a1 1 0 0 0 2 0v-.95l.84 1a1 1 0 0 0 1.53-1.28L13 16.94v-2.13q.52-.18.94-.54l1.84 1.07 1.26 3.47a1 1 0 1 0 1.88-.69l-.44-1.23.81.47a1 1 0 0 0 1-1.73l-.81-.47 1.28-.23a1 1 0 1 0-.34-1.97M12 13a1 1 0 0 1 0-2 1 1 0 0 1 0 2"></path>
                        </svg>
                      </div>
                    </farex-icon>
                  </div>
                  <div className="farex-col-10">
                    <h3 className="farex-h3 farex-h3--section-header">
                      Air conditioning
                    </h3>
                    <div className="farex-text">
                      <p>
                        Beat the heat and enjoy a refreshing journey with
                        temperature-controlled interiors.
                        <br />
                        Our A/C on board transforms your ride into a cool,
                        comfortable experience.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="farex-col-12 farex-col-6-md text-with-icon-item">
                <div className="farex-grid">
                  <div className="farex-col-2">
                    <farex-icon
                      size="cover"
                      name="person"
                      color="primary"
                      aria-hidden="true"
                    >
                      <div className="inner color color-primary size size-cover">
                        <svg
                          fill="#dd3751"
                          height={"60px"}
                          width={"60px"}
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          className="farex-icon person"
                        >
                          <path d="M14.98 11.59a5.37 5.37 0 0 1-5.95 0A6 6 0 0 0 4 17.5v3.9c0 .33.27.6.6.6h14.8a.6.6 0 0 0 .6-.6v-3.9a6 6 0 0 0-5.02-5.91M18 20H6v-2.5a4 4 0 0 1 2.72-3.78 7.3 7.3 0 0 0 6.56 0A4 4 0 0 1 18 17.5zm-6-9.5c2.07 0 3.75-1.9 3.75-4.25C15.75 3.91 14.07 2 12 2S8.25 3.9 8.25 6.25c0 2.34 1.68 4.25 3.75 4.25M12 4c.95 0 1.75 1.03 1.75 2.25S12.95 8.5 12 8.5s-1.75-1.03-1.75-2.25S11.05 4 12 4"></path>
                        </svg>
                      </div>
                    </farex-icon>
                  </div>
                  <div className="farex-col-10">
                    <h3 className="farex-h3 farex-h3--section-header">Hosts</h3>
                    <div className="farex-text">
                      <p>
                        Hosts are always available to aid you with your trip.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="farex-col-12 farex-col-6-md text-with-icon-item">
                <div className="farex-grid">
                  <div className="farex-col-2">
                    <farex-icon
                      size="cover"
                      name=" farex-icon-q-and-a"
                      color="primary"
                      aria-hidden="true"
                    >
                      <div className="inner color color-primary size size-cover">
                        <svg
                          fill="#dd3751"
                          height={"60px"}
                          width={"60px"}
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          className="farex-icon q-and-a"
                        >
                          <path d="M22 11.2v5.6c0 1.15-.63 2.1-1.4 2.1h-1.4v1.43c0 .44-.25.67-.63.67q-.47 0-1.1-.42L15 18.9h-4.9A2.1 2.1 0 0 1 8 16.8v-.03l2-1.37v1.4q.01.09.1.1h5.52l.5.34 1.08.74V16.9H20v-5.7q-.01-.09-.1-.1H19v-2h.9c1.16 0 2.1.94 2.1 2.1m-12 3-2.82 1.92q-.73.48-1.26.48c-.44 0-.72-.26-.72-.77V14.2H3.6c-.88 0-1.6-1.07-1.6-2.4V5.4A2.4 2.4 0 0 1 4.4 3h11.2A2.4 2.4 0 0 1 18 5.4v6.4a2.4 2.4 0 0 1-2.4 2.4zm0-.38a2 2 0 0 0 1.96-1.62h3.64a.4.4 0 0 0 .4-.4V5.4a.4.4 0 0 0-.4-.4h-2.65a3.4 3.4 0 0 0-2.93-1.68c-1.24 0-2.36.66-2.98 1.68H4.4a.4.4 0 0 0-.4.4v6.4q.01.24.05.4H7.2v1.48l1.13-.77a2 2 0 0 0 1.67.9M9.88 7.4l-.13.13c-.22.22-.8.8-.8 1.78 0 .54.43.99.98.99.54 0 .99-.45.99-1.06q0-.09.21-.3l.1-.1c.39-.36 1.19-1.1 1.19-2.1a2.36 2.36 0 0 0-2.4-2.43 2.46 2.46 0 0 0-2.42 2 1 1 0 0 0 .81 1.14c.54.08 1.04-.26 1.15-.86.07-.18.25-.3.45-.3q.43.01.43.44s-.03.18-.56.67M11 11.8a1 1 0 1 0-2 0 1 1 0 0 0 2 0"></path>
                        </svg>
                      </div>
                    </farex-icon>
                  </div>
                  <div className="farex-col-10">
                    <h3 className="farex-h3 farex-h3--section-header">Help</h3>
                    <div className="farex-text">
                      <p>
                        Our&nbsp;
                        <Link to={"/contact-us"}>Help page</Link>
                        &nbsp;provides answers to lots of your questions.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};
